import React from "react";
import styled from "styled-components";
import { breakpoint } from "@utilities";

const BannerWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
    border: 1.5px solid var(--primary-color);
    border-radius: 12px;
    background: linear-gradient(90deg, #fafdff 0%, #e6fafd 100%);
    padding: 16px 12px;
    margin-top: 0;
    margin-bottom: 32px;
    margin-left: auto;
    margin-right: auto;
    min-height: 80px;
    box-sizing: border-box;
    font-family: "Poppins";

    ${breakpoint.breakOnlyMobile`
        margin:0 16px 32px 16px;
    `}
    ${breakpoint.breakMobileMedium`
        width: ${(props) => props.theme.widths.wide_700};
    `}
    ${breakpoint.breakTablet`
        width: ${(props) => props.theme.widths.wide_700};   
    `}
    ${breakpoint.breakIpadPro`
        width: ${(props) => props.theme.widths.wide_850}; 
    `}
    ${breakpoint.breakLarge`
        width: ${(props) => props.theme.widths.wide_1110};
    `}
    ${breakpoint.breakTablet`
        padding: 16px 24px;
    `}
`;

const BannerText = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
`;

const Headline = styled.div`
    font-size: 0.875rem;
    font-weight: 600;
    color: #3c3c3c;
    margin-bottom: 4px;
`;

const Subtext = styled.div`
    font-size: 0.875rem;
    color: #6e7375;
    font-weight: 300;
`;

const LearnMore = styled.a`
    color: var(--primary-color);
    font-weight: 500;
    font-size: 0.875rem;
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.2s;
    &:hover {
        text-decoration: underline;
    }
`;

export interface DiscountBannerProps {
    activeDiscountPercent: number;
    learnMoreHref: string;
}

export const DiscountBanner: React.FC<DiscountBannerProps> = ({
    activeDiscountPercent,
    learnMoreHref,
}) => (
    <BannerWrapper>
        <img src="/images/DiscountPercent.svg" alt="Discount percent icon" />
        <BannerText>
            <Headline>Get up to {activeDiscountPercent}% off upon checkout.</Headline>
            <Subtext>Travel more, spend less.</Subtext>
        </BannerText>
        <LearnMore href={learnMoreHref}>Learn More</LearnMore>
    </BannerWrapper>
);
